// src/api/corralPurchasesAdminApi.ts
import client from "./client";

export type CorralPurchaseStatus = "PENDING" | "PAID" | "FAILED" | "CANCELLED" | "REFUNDED";

export interface CorralPurchaseAdminItem {
  id: string;
  userId: string;
  userFullName: string;
  userEmail?: string;
  quantity: number | null;
  unlimited: boolean;
  subtotal: number;
  discountAmount: number;
  total: number;
  currency: string;
  status: CorralPurchaseStatus;
  externalTransactionId?: string | null;
  purchaseDate: string;
  paidAt?: string | null;
  expiresAt?: string | null;
}

interface AdminEnvelope<T> {
  code: number;
  message: string;
  content: T;
  totalElements?: number;
  totalPages?: number;
}

export const corralPurchasesAdminApi = {
  listar: (page = 0, size = 20, status?: CorralPurchaseStatus | "") =>
    client.get<AdminEnvelope<CorralPurchaseAdminItem[]>>(
      "/api/v1/admin/corrals/purchases",
      { params: { page, size, status: status || undefined } },
    ),

  /**
   * El panel admin NUNCA aprueba un pago directamente — solo le pide al
   * backend que vuelva a consultarle la verdad a Wompi (con la llave
   * privada) y aplique el mismo flujo de verificación que el webhook. Los
   * Corrales solo se generan si Wompi confirma APPROVED.
   */
  reconciliar: (id: string, wompiTransactionId?: string) =>
    client.post<AdminEnvelope<unknown>>(
      `/api/v1/admin/corrals/purchases/${id}/reconcile`,
      undefined,
      { params: wompiTransactionId ? { wompiTransactionId } : undefined },
    ),
};
